import { render, staticRenderFns } from "./DataTableAdmins.vue?vue&type=template&id=56766ed7&scoped=true&"
import script from "./DataTableAdmins.vue?vue&type=script&lang=js&"
export * from "./DataTableAdmins.vue?vue&type=script&lang=js&"
import style0 from "./DataTableAdmins.vue?vue&type=style&index=0&id=56766ed7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56766ed7",
  null
  
)

export default component.exports